import React from 'react';
import PropTypes from 'prop-types';
import './style';

const Icon = (props) => {
  const {
    children,
    className,
    type,
    ...attr
  } = props;

  return (
    <div
      className={`icon-wrapper size-fit ${type} ${className}`}
      {...attr}
    >
      {children}
    </div>
  );
};

Icon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.oneOf(['square', 'circle', 'default']),
};

Icon.defaultProps = {
  children: null,
  className: '',
  type: 'default',
};

export default Icon;
